import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VApp,{staticClass:"app"},[_c('Loading'),_c('ErrorAlert'),_c('WarningAlert'),_c('SuccessAlert'),(_vm.showPrivacyWarning)?_c('PrivacyWarning'):_vm._e(),_c('AppBar',{attrs:{"show-app-bar":_vm.showAppBar}}),_c(VMain,[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(Component,{tag:"component"})],1)]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }